module.exports = __webpack_public_path__ + "img/edit-blue.a0d54032.svg";